import React from "react";

export default function MSAccess_IsNull() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_IsNull</h1>
      <p>This is the MSAccess_IsNull component generated from the SQL JSON.</p>
    </div>
  );
}
